module.exports = __webpack_public_path__ + "img/icon12.161a2612.svg";